import { useQuery } from "@tanstack/react-query";
import { getMyPlanFeaturesApiV1PlansMyPlanFeaturesGet } from "@/backend-sdk/client/sdk.gen";
import type {
  MyPlanFeaturesResponse,
  PlanFeatureItem,
} from "@/backend-sdk/client/types.gen";
import type { FeatureSlug } from "@/lib/feature-gates";

export const planFeaturesQueryKey = ["my-plan-features"] as const;

export function usePlanFeatures() {
  const query = useQuery<MyPlanFeaturesResponse>({
    queryKey: planFeaturesQueryKey,
    queryFn: async () => {
      const { data } = await getMyPlanFeaturesApiV1PlansMyPlanFeaturesGet({
        throwOnError: true,
      });
      return data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const isEnabled = (slug: FeatureSlug): boolean => {
    return query.data?.features[slug]?.is_enabled ?? false;
  };

  const getFeature = (slug: FeatureSlug): PlanFeatureItem | undefined => {
    return query.data?.features[slug];
  };

  return {
    features: query.data?.features ?? {},
    categories: query.data?.categories ?? [],
    planName: query.data?.plan_name ?? null,
    planId: query.data?.plan_id ?? null,
    isEnabled,
    getFeature,
    isLoading: query.isPending,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
